function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#252F32",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.996 40a19.999 19.999 0 1114.14-5.852A19.945 19.945 0 0119.997 40zm0-39.113a19.096 19.096 0 1013.509 5.596A19.048 19.048 0 0019.995.887z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.483 15.878l6.85-6.85.638.638-6.85 6.85z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.02 18.824h-7.844V10.98h.905v6.939h6.939zM8.728 30.633l6.85-6.85.638.638-6.85 6.85z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.04 29.804h-.906v-6.938h-6.938v-.905h7.843z"
}));
function SvgImgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgImgClose;